import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=44c13832&scoped=true&lang=scss"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44c13832"]])

export default __exports__